/** ISO 3166-1 alpha-2 codes; names come from the browser (Intl.DisplayNames) in the page's language. */
const CODES =
  `AF AX AL DZ AS AD AO AI AQ AG AR AM AW AU AT AZ BS BH BD BB BY BE BZ BJ BM BT BO BQ BA BW BR IO BN BG BF BI CV KH CM CA KY CF TD CL CN CX CC CO KM CG CD CK CR CI HR CU CW CY CZ DK DJ DM DO EC EG SV GQ ER EE SZ ET FK FO FJ FI FR GF PF GA GM GE DE GH GI GR GL GD GP GU GT GG GN GW GY HT VA HN HK HU IS IN ID IR IQ IE IM IL IT JM JP JE JO KZ KE KI KP KR XK KW KG LA LV LB LS LR LY LI LT LU MO MG MW MY MV ML MT MH MQ MR MU YT MX FM MD MC MN ME MS MA MZ MM NA NR NP NL NC NZ NI NE NG NU NF MK MP NO OM PK PW PS PA PG PY PE PH PN PL PT PR QA RE RO RU RW BL SH KN LC MF PM VC WS SM ST SA SN RS SC SL SG SX SK SI SB SO ZA GS SS ES LK SD SR SJ SE CH SY TW TJ TZ TH TL TG TK TO TT TN TR TM TC TV UG UA AE GB US UY UZ VU VE VN VG VI WF EH YE ZM ZW`.split(
    ' '
  );

const cache: Record<string, Array<{ code: string; name: string }>> = {};

export function countryName(
  code: string | null | undefined,
  locale = 'fr'
): string {
  if (!code) return '';
  try {
    return (
      new Intl.DisplayNames([locale], { type: 'region' }).of(
        code.toUpperCase()
      ) ?? code
    );
  } catch {
    return code;
  }
}

export function countries(
  locale = 'fr'
): Array<{ code: string; name: string }> {
  if (!cache[locale]) {
    cache[locale] = CODES.map((code) => ({
      code,
      name: countryName(code, locale),
    })).sort((a, b) => a.name.localeCompare(b.name, locale));
  }
  return cache[locale];
}

/** Flag emoji of a country code. */
export function flag(code: string | null | undefined): string {
  if (!code || code.length !== 2) return '';
  return String.fromCodePoint(
    ...code
      .toUpperCase()
      .split('')
      .map((c) => 0x1f1a5 + c.charCodeAt(0))
  );
}
